import { MessageCircle } from 'lucide-react';

function buildText(text) {
  return encodeURIComponent(text);
}

export default function WhatsAppShare({ text, label = 'Share on WhatsApp', className = '', testId = 'whatsapp-share' }) {
  const href = `https://wa.me/?text=${buildText(text)}`;
  return (
    <a
      data-testid={testId}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white px-4 py-2 text-sm font-semibold transition-all hover:-translate-y-0.5 ${className}`}
    >
      <MessageCircle className="w-4 h-4" />
      {label}
    </a>
  );
}
